import { render, staticRenderFns } from "./UDocuments.vue?vue&type=template&id=0626e2f2&scoped=true&"
import script from "./UDocuments.vue?vue&type=script&lang=js&"
export * from "./UDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UDocuments.vue?vue&type=style&index=0&id=0626e2f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0626e2f2",
  null
  
)

export default component.exports